import { jsxs as l, jsx as o } from "react/jsx-runtime";
import * as r from "@radix-ui/react-slider";
import n from "clsx";
import * as f from "react";
import { cn as s } from "../../utils.js";
const b = f.forwardRef(({ className: a, defaultValue: t, ...e }, i) => /* @__PURE__ */ l(
  r.Root,
  {
    ref: i,
    className: s(
      "relative flex w-full touch-none select-none items-center",
      a
    ),
    defaultValue: t !== void 0 ? [t] : [],
    ...e,
    children: [
      e.min !== void 0 && /* @__PURE__ */ o("p", { className: "absolute -bottom-2.5 left-0 text-xs font-normal leading-[14.4px] text-onSurface-400", children: e.min }),
      e.max !== void 0 && /* @__PURE__ */ o("p", { className: "absolute -bottom-2.5 right-0 text-xs font-normal leading-[14.4px] text-onSurface-400", children: e.max }),
      /* @__PURE__ */ o(r.Track, { className: "relative h-0.5 w-full grow overflow-hidden rounded-full bg-onSurface-400", children: /* @__PURE__ */ o(r.Range, { className: "absolute h-full bg-primary" }) }),
      /* @__PURE__ */ o(
        r.Thumb,
        {
          className: n(
            "peer block size-2 cursor-pointer rounded-full border-2 border-[#3851C5] bg-[#3851C5] transition-colors  disabled:pointer-events-none disabled:opacity-50",
            "before:duration-[0.2s] before:ease-[ease-in-out] before:absolute before:-top-5 before:flex before:size-4 before:-translate-x-1/4 before:translate-y-[-0%] before:items-center before:justify-center before:rounded before:border-2 before:border-onSurface-300 before:bg-white before:p-0.5 before:text-xs before:font-normal before:leading-[14.4px] before:opacity-0 before:transition-opacity before:content-[attr(aria-valuenow)] hover:before:opacity-100"
          )
        }
      )
    ]
  }
));
b.displayName = r.Root.displayName;
export {
  b as Slider
};
